module.exports = __webpack_public_path__ + "assets/img/pager.9890a2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pager.jpg
// module id = puuM
// module chunks = 1